import { useState } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
const Row = styled.div`
  border-bottom: 1px solid var(--vo-cloud);
  overflow: hidden;
`

const SummaryRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  cursor: pointer;
  transition: background 0.15s;
  user-select: none;

  &:hover {
    background: var(--vo-capri-25);
  }
`

const Chevron = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  color: var(--vo-slate);
  transition: transform 0.2s ease;

  ${({ $open }) =>
    $open &&
    css`
      transform: rotate(180deg);
    `}

  svg {
    width: 16px;
    height: 16px;
    fill: currentColor;
  }
`

const SummaryContent = styled.div`
  flex: 1;
  min-width: 0;
`

const ExpandedContent = styled.div`
  overflow: hidden;
  max-height: ${({ $open }) => ($open ? '2000px' : '0')};
  transition: max-height 0.2s ease;
`

const ExpandedInner = styled.div`
  padding: 12px 16px 16px;
  background: var(--vo-white);
`

const ChevronDownSvg = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 10l5 5 5-5z" />
  </svg>
)

export const ExpandableRow = ({ summary, children, defaultOpen, onToggle }) => {
  const [open, setOpen] = useState(defaultOpen ?? false)

  const handleToggle = () => {
    const next = !open
    setOpen(next)
    onToggle?.(next)
  }

  return (
    <Row>
      <SummaryRow onClick={handleToggle} role="button" aria-expanded={open}>
        <Chevron $open={open}>
          <ChevronDownSvg />
        </Chevron>
        <SummaryContent>{summary}</SummaryContent>
      </SummaryRow>
      <ExpandedContent $open={open}>
        <ExpandedInner>{children}</ExpandedInner>
      </ExpandedContent>
    </Row>
  )
}

ExpandableRow.propTypes = {
  summary: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  defaultOpen: PropTypes.bool,
  onToggle: PropTypes.func,
}
